import { Component, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { TripFinanceService } from '../../../../../../api/trip-finance.service';
import { OverDuePaymentsResponse, OverduePayment } from '../../../../../../api/types/recruiting';
import { UiModule } from 'src/app/ui/ui.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { Column, TableColumnComponent, TableHeaderComponent } from 'src/app/ui/tables';


@Component({
  selector: 'app-my-overdue-payments',
  templateUrl: './my-overdue-payments.component.html',
  styleUrls: ['./my-overdue-payments.component.scss'],
  standalone: true,
  imports: [CommonModule, UiModule, RouterModule, CardModule, TableModule, TableColumnComponent, TableHeaderComponent]
})
export class MyOverduePaymentsComponent implements OnInit {
  overduePayments = signal<OverduePayment[]>([]);
  paymentSummary: { totalPaid: number; totalDue: number } = { totalPaid: 0, totalDue: 0 };
  loading = true;
  error: string | null = null;

  columns: WritableSignal<Column<OverduePayment>[]> = signal([
    { field: 'groupName', header: 'Group Name', type: 'groupNameWithLink', custIdField: 'custID', sortable: true, filterable: true },
    { field: 'locationName', header: 'Location', type: 'text', sortable: true, filterable: true },
    { field: 'chargeDueDate', header: 'Due', type: 'date', sortable: true, filterable: true },
    { field: 'chargeTypeID', header: 'Type', type: 'text', sortable: true, filterable: true },
    { field: 'chargeAmount', header: 'Total', type: 'currency', sortable: true, filterable: true }
  ]);

  @Input() staffId: number = 0;

  constructor(
    private tripFinanceService: TripFinanceService
  ) {}

  ngOnInit() {
    if (!this.staffId) return;
    this.loadOverduePayments(this.staffId);
  }

  private loadOverduePayments(staffId: number) {
    this.loading = true;
    this.tripFinanceService.getOverduePaymentsForStaff(staffId).subscribe({
      next: (data) => {
        this.overduePayments.set(data.overduePayments);
        this.paymentSummary = data.paymentSummary;
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Failed to load overdue payments';
        this.loading = false;
        console.error('Error loading overdue payments:', err);
      }
    });
  }

  getPaymentPercentage(): number {
    if (!this.paymentSummary?.totalDue || this.paymentSummary.totalDue === 0) {
      return 0;
    }
    return (this.paymentSummary.totalPaid / this.paymentSummary.totalDue) * 100;
  }

  getChargeTypeName(chargeTypeId: number): string {
    switch (chargeTypeId) {
      case 1:
        return 'Reg. Fee';
      case 2:
        return 'First Pmt.';
      case 3:
        return 'Last Pmt.';
      default:
        return 'Other';
    }
  }

  hasOverduePayments(): boolean {
    return !!this.overduePayments().length;
  }

  getTotalDue(): number {
    return this.paymentSummary.totalDue;
  }

  getTotalPaid(): number {
    return this.paymentSummary.totalPaid;
  }

  getRemainingAmount(payment: OverduePayment): number {
    return payment.chargeAmount - payment.chargeAmountPaid - payment.discountAmount;
  }
} 